module.exports = __webpack_public_path__ + "static/media/dnd_logo.51b7c5ba.png";